import { Model, Prompt } from '../../../../Types';
import AdminViewCard from '../../../Utility/AdminViewCard';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';
import { PaginationWrapper } from '../../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { modelService } from '../../../../Services/modelService';
import useSearchFilter from '../../../../Hooks/useSearchFilter';
import SearchFilter from '../../../Utility/SearchFilter';
import { promptService } from '../../../../Services/promptService';

interface ModelTabProps {
    prompt: Prompt;
    i18n: any;
    handleDropdownChange: any;
    isUserPrompt: boolean;
}

function ModelTab({ prompt, i18n, handleDropdownChange, isUserPrompt }: ModelTabProps) {
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    return (
        <div className="w-full">
            <TabHeadline title={i18n.translate({ id: 'tabs.model.title', sourceName: 'Prompt' })} />
            <InfoButton customContent={<div>Some Test</div>} configKey="model" />
            {!isUserPrompt && (
                <SearchFilter
                    value={localQuery}
                    onChange={searchActions.setLocalQuery}
                    onApply={searchActions.applyQuery}
                    onClear={searchActions.clearQuery}
                    className="mb-6"
                />
            )}

            <PaginationWrapper
                listType={PaginationListType.Models}
                itemsFunction={
                    !isUserPrompt
                        ? modelService.getModelsByPage
                        : async () => {
                              return {
                                  data: await promptService.getModels(isUserPrompt),
                                  totalCount: 2,
                              };
                          }
                }
                itemsPerPage={12}
                query={query ?? null}
                renderItem={(model: Model, index: number) => (
                    <AdminViewCard
                        key={model.identifier}
                        identifier={model.identifier}
                        title={model.title}
                        image={model.image}
                        handleChangeFunction={handleDropdownChange}
                        isActive={prompt.model === model.identifier}
                    />
                )}
                className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 2xl:grid-cols-3 gap-3"
            />
        </div>
    );
}

export default ModelTab;
